import { assert_false } from '@shared/asserts/utils_asserts';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function use_navigate_ud() {
  const navigate = useNavigate();
  const location = useLocation();

  async function navigate_ud(path: string, options?: { replace?: boolean; keep_search_params?: boolean }) {
    if (options?.keep_search_params) {
      //path already contains search params
      assert_false(path.includes('?'));

      path = `${path}${location.search}`;
    }

    await navigate(path, options);
  }

  const navigate_ud_cached = useCallback(navigate_ud, [location]);

  return navigate_ud_cached;
}
